import React, { Component } from 'react';
import '../../App.css';
import WordSearch from '../layout/WordSearch';
import axios from 'axios';
import WordResults from '../layout/WordResults';

class Words extends Component {

    state = {
        loading: false,
        alert: null,
        word_holder: [],
        base_url: '',
      }

    searchUrl = async text => {

    this.extractData(text);
    
    }

    searchTerm = async inputTerm => {
        //console.log(inputTerm);
        this.setState({searchTerm: inputTerm});
    }

    setAlert = (msg, type) => {
        this.setState({ alert: {msg: msg, type: type} });
        setTimeout(() => this.setState({ alert: null }), 5000)
    }

    extractData = async (text) => {

        
        await axios.get(text).then(res => {
            this.setState({base_url: this.exrtactBaseURL(text)});
            this.extract_content(res.data);

            return this.state.word_holder;
        })

    }

    exrtactBaseURL = (search_url) => {
        //extract base URL
        var pathArray = search_url.split( '/' );
        var protocol = pathArray[0];
        var host = pathArray[2];
        this.base_url = protocol.toString().toLowerCase() + '//' + host.toString().toLowerCase();
    }

    extract_content = (data) => {

        this.setState({word_holder: []});

        while(data.indexOf(this.state.searchTerm)>1){
            const termLoc = data.indexOf(this.state.searchTerm);
            const termEnd = termLoc + 25;
            const termValue = data.substring(termLoc, termEnd);

            this.setState({word_holder: this.state.word_holder.concat({term:termValue})});

            data = data.substring(termEnd);
        }
        console.log(this.state.word_holder);
        return this.state.word_holder;
    }

    render() {
        return (
            <div>
                  <div className='container'>
                    <h3><b>WORD SEARCH</b></h3>
                    <WordSearch searchUrl={this.searchUrl} setAlert={this.setAlert} searchTerm={this.searchTerm}/>
                  </div>
                  <br/>
                  <WordResults word_holder={this.state.word_holder}/>
                  <br/>
                  <br/>
            </div>
        )
    }
}

export default Words



// WEBPACK FOOTER //
// ./src/components/pages/Words.js